/**
 * Action for wordpress/settings module
 */
import wpAPI from '@/api/wordpress'
import {errorHandler} from '@/helpers'
import types from './types'

const actions = {
  /**
   * 設定情報の取得
   */
  async [types.FETCH] ({ dispatch, commit, getters, rootGetters }) {
    return wpAPI.getSettings().then(res => {
      commit(types.FETCH, res.data)
      return res.data
    }).catch(errorHandler)
  },

  /**
   * 設定情報の更新
   */
  async [types.UPDATE] ({ dispatch, commit, getters, rootGetters }, settings) {
    return wpAPI.updateSettings(settings).then(res => {
      commit(types.UPDATE, res.data)
      return res.data
    }).catch(errorHandler)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/settings/actions.js